import { 
  Component, 
  Input
} from '@angular/core';
import { 
  NavController,
  ModalController,
  PopoverController
} from 'ionic-angular';

// Providers
import { NotificationsService } from '../../../providers/notifications/notifications-service';
import { InstructorsService } from '../../../providers/instructors/instructors-service';
import { RecertificationService } from '../../../providers/instructors/recertification-service';
import { ProvidersService } from '../../../providers/providers/providers-service';

// Modals
import { ProviderInfoModalPage } from '../../../components/modals/provider-info.modal';

// Popovers
import { CertifiedHoursPopoverPage } from '../../../components/popovers/certified-hours.popover';

// Pages
import { InstructorAddEditPage } from '../../instructors/instructor-add-edit';
import { RecertificationViewPage } from '../../recertifications/recertification-view';

@Component({
  selector: 'dashboard-notifications',
  templateUrl: 'dashboard-notifications.component.html'
})

export class DashboardNotificationsComponent
{
  @Input() color: string;
  
  notifications: any = [];
  count: number = 0;

  constructor(
    public notificationsService: NotificationsService,
    public instructorsService: InstructorsService,
    public recertificationService: RecertificationService,
    public providersService: ProvidersService,
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public popoverCtrl: PopoverController
  )
  {
    setTimeout(() => {
      this.getNotifications();    
    }, 500);
  }

  getNotifications()
  {
    this.notificationsService.getNotifications(  )
      .subscribe( data => {
        this.notifications = data;
        this.count = this.notifications.length;
      });
  }

  clearNotification( notification )
  {
    notification.status = 'Cleared';
    this.notificationsService.clearNotification( notification )
      .subscribe( data => {
        // Remove notification from array
        for ( let i in this.notifications )
        {
          if ( this.notifications[i].notification_id === notification.notification_id )
          {
            this.notifications.splice(i, 1);
          }
        }
      });
  }

  clearAllNotifications()
  {

  }

  showInstructorAddEditPage( instructorId )
  {
    this.instructorsService.getInstructor( instructorId )
      .subscribe( data => {
        this.navCtrl.push( InstructorAddEditPage, {
          instructor: data
        });
      });
    return false;
  }

  showRecertificationPage( recertificationId )
  {
    this.recertificationService.getRecertification( recertificationId )
      .subscribe( data => {
        this.navCtrl.push( RecertificationViewPage, {
          recertification: data
        });
      });
    return false;
  }

  presentProviderModal( providerId )
  {
    // Get provider info.
    this.providersService.getProvider( providerId )
      .subscribe( data => {
        let modal = this.modalCtrl.create( ProviderInfoModalPage, {
          editData: data
        });
        modal.present();
      });
  }

  presentCertifiedHoursPopover( secureDataSubmitId, ev )
  {
    let popover = this.popoverCtrl.create( CertifiedHoursPopoverPage, {
      secureDataSubmitId: secureDataSubmitId
    });
    popover.present({
      ev: ev
    });

    popover.onDidDismiss(data => {
      /*
      switch( data )
      {
        case 'add-continuing-ed':
          this.addContinuingEdBulk();
          break;
        case 'delete':
          this.deleteInstructorsBulk();
          break;

      }
      */
    });   
  }

  ngOnInit()
  {
  }
}  


// WEBPACK FOOTER //
// ./src/pages/dashboard/components/dashboard-notifications.component.ts